import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const eventsSlice = createSlice({
  name: 'eventsSliceName',
  initialState,
  reducers: {
    addEvents: (state) => {
      state.loading = true;
    },
    getEvents: (state) => {
      state.loading = true;
    },
    getOneEvents: (state) => {
      state.loading = true;
    },
    successEvents: (state, action) => {
      if (action.payload && action.payload.data && Array.isArray(action.payload.data)) {
        state.data = action.payload.data;
      } else if (action.payload && Array.isArray(action.payload)) {
        state.data = action.payload;
      } else {
        state.data = action.payload && action.payload.data ? action.payload.data : action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removeEvents: (state) => {
      state.loading = true;
    },
    updateEvents: (state) => {
      state.loading = true;
    },
    toggleEvents: (state) => {
      state.loading = true;
    },
    failedEvents: (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Something went wrong';
    },
  },
})

export const { addEvents, removeEvents, updateEvents, getEvents, successEvents, getOneEvents, toggleEvents, failedEvents } = eventsSlice.actions

export default eventsSlice.reducer
